
import {observer} from 'mobx-react-lite';
import {getLocalesByKey as t} from '@/utils/translation';
import styles from '@/components/layoutV2/header/style.module.scss';
import styled from 'styled-components';

import {CountryDropdownV2} from '@/components/common-components/v2/CountryDropdownV2/CountryDropdownV2';
interface Props {
  isDocked?: boolean;
}
export const RenderCountrySelect = observer(({isDocked}:Props) => {
  return (
    <>
      <Wrap className={isDocked ? styles.drop : styles.dropDockedSidebar}>
        {isDocked && <span style={{marginLeft: '23px', color: '#a3a4a4', fontSize: '12px'}}>{t('Location')}</span> }
        <div style={{marginTop: '-6px'}}>
          <CountryDropdownV2 mode='dark' />
        </div>
      </Wrap>
    </>
  );
});

const Wrap = styled.div`
padding-top: 6px;
background: rgba(84, 86, 90, 0.17);
&:hover{
background: rgba(84, 86, 90, 0.17) !important;
}
.countryPickerPopoverTriggerClass {
position: relative !important;
background: transparent;
width: -webkit-fill-available !important;
img{
    height: 24px !important;
    left: -21px !important;
    position: absolute !important;
    top: -10px !important;
    width: 30px !important;
  }
    .fa-caret-down {
    margin-left: 50px !important;
    position: absolute;
    right: 0;
    margin-right: 9px;
    font-size: 16px;
    margin-top: -17px;
    }
    span{
    margin-left: 15px !important;
    }
    svg{
    margin-left: -20px;
    margin-top: -31px;
    }
}
`;
